import type { MessageInstance } from 'antd/lib/message/interface';
import type { NotificationInstance } from 'antd/lib/notification/interface';
import type { ModalStaticFunctions } from 'antd/es/modal/confirm';

// ---------------------------------------------------------------------------
// Registro interno — solo el binder escribe aquí
// ---------------------------------------------------------------------------

export interface MessagingApi {
  message: MessageInstance;
  notification: NotificationInstance;
  modal: Omit<ModalStaticFunctions, 'warn'>;
}

let api: MessagingApi | null = null;

function requireApi(): MessagingApi {
  if (!api) {
    throw new Error('[messaging] No inicializado. AntMessaging debe montarse dentro de <App> antes de usar message/notification/modal.');
  }
  return api;
}

/** Llamado por el binder para registrar la API contextual de Ant Design. */
export function bindMessagingApi(instance: MessagingApi): void {
  api = instance;
}

// ---------------------------------------------------------------------------
// Fachada estable — estos objetos nunca cambian de referencia
// ---------------------------------------------------------------------------

export const message: MessageInstance = {
  open: (...args) => requireApi().message.open(...args),
  destroy: (...args) => requireApi().message.destroy(...args),
  success: (...args) => requireApi().message.success(...args),
  error: (...args) => requireApi().message.error(...args),
  warning: (...args) => requireApi().message.warning(...args),
  info: (...args) => requireApi().message.info(...args),
  loading: (...args) => requireApi().message.loading(...args),
};

export const notification: NotificationInstance = {
  open: (...args) => requireApi().notification.open(...args),
  destroy: (...args) => requireApi().notification.destroy(...args),
  success: (...args) => requireApi().notification.success(...args),
  error: (...args) => requireApi().notification.error(...args),
  warning: (...args) => requireApi().notification.warning(...args),
  info: (...args) => requireApi().notification.info(...args),
};

export const modal: Omit<ModalStaticFunctions, 'warn'> = {
  confirm: (...args) => requireApi().modal.confirm(...args),
  info: (...args) => requireApi().modal.info(...args),
  success: (...args) => requireApi().modal.success(...args),
  error: (...args) => requireApi().modal.error(...args),
  warning: (...args) => requireApi().modal.warning(...args),
};

// Para tests
export function _resetForTest(): void {
  api = null;
}
